import { useEffect, useState } from "react";
import { fetchExecutiveAccessList, setExecutiveAccess, type ExecutiveListing } from "../lib/api";

export default function ExecutiveAccessPanel() {
  const [people, setPeople] = useState<ExecutiveListing[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busyEmail, setBusyEmail] = useState<string | null>(null);

  useEffect(() => {
    fetchExecutiveAccessList()
      .then(setPeople)
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load"));
  }, []);

  async function toggle(email: string, next: boolean) {
    setBusyEmail(email);
    setError(null);
    try {
      const updated = await setExecutiveAccess(email, next);
      setPeople((prev) => prev?.map((p) => (p.email === email ? updated : p)) ?? null);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to update");
    } finally {
      setBusyEmail(null);
    }
  }

  return (
    <section className="di-card">
      <h2 className="di-h4">Executive access</h2>
      <p className="di-small">
        Controls who sees this Org-wide view. Since this is granted manually rather than derived
        from the People sheet, manage it here instead of asking for a database change.
      </p>

      {error && <p className="form-error">{error}</p>}

      {people === null ? (
        <p className="di-small">Loading…</p>
      ) : (
        <div className="table-scroll">
          <table className="di-table">
            <thead>
              <tr>
                <th>Person</th>
                <th>Executive access</th>
              </tr>
            </thead>
            <tbody>
              {people.map((p) => (
                <tr key={p.email}>
                  <td>
                    {p.name} <span className="di-small deny-reason">{p.email}</span>
                  </td>
                  <td className="actions-cell">
                    <button
                      className={`di-btn di-btn-small ${p.isExecutive ? "di-btn-primary" : "di-btn-outline"}`}
                      disabled={busyEmail === p.email}
                      onClick={() => toggle(p.email, !p.isExecutive)}
                    >
                      {busyEmail === p.email ? "Saving…" : p.isExecutive ? "Executive" : "Grant access"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
